"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var ExpirationStyle;
(function (ExpirationStyle) {
    ExpirationStyle["Weekly"] = "WEEKLY";
    ExpirationStyle["Monthly"] = "MONTHLY";
    ExpirationStyle["Quarterly"] = "QUARTERLY";
})(ExpirationStyle = exports.ExpirationStyle || (exports.ExpirationStyle = {}));
function ExpirationStyleFromJSON(json) {
    return ExpirationStyleFromJSONTyped(json, false);
}
exports.ExpirationStyleFromJSON = ExpirationStyleFromJSON;
function ExpirationStyleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ExpirationStyleFromJSONTyped = ExpirationStyleFromJSONTyped;
function ExpirationStyleToJSON(value) {
    return value;
}
exports.ExpirationStyleToJSON = ExpirationStyleToJSON;
